import React from 'react';
import { Typography, IconButton, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Edit as EditIcon, Delete as DeleteIcon, Visibility as VisibilityIcon } from '@mui/icons-material';
import { DatabaseTable } from '../../../../shared/components/ui/DatabaseTable';
import type { Reservation } from '../../../../shared/services/reservation/reservationService';

interface ReservationTableProps {
  reservations: Reservation[];
  isLoading: boolean;
  onView: (reservation: Reservation) => void;
  onEdit: (reservation: Reservation) => void;
  onDelete: (reservation: Reservation) => void;
}

export function ReservationTable({
  reservations,
  isLoading,
  onView,
  onEdit,
  onDelete
}: ReservationTableProps) {
  const theme = useTheme();

  const columns = [
    {
      field: 'name',
      headerName: 'Nome da Reserva',
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.row.name}
        </Typography>
      )
    },
    {
      field: 'roomName',
      headerName: 'Área/Sala',
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.row.roomName || 'Não informado'}
        </Typography>
      )
    },
    {
      field: 'userName',
      headerName: 'Responsável',
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.row.userName || 'Não informado'}
        </Typography>
      )
    },
    {
      field: 'startDate',
      headerName: 'Data/Hora Início',
      width: 160,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {new Date(params.row.startDate).toLocaleString('pt-BR')}
        </Typography>
      )
    },
    {
      field: 'endDate',
      headerName: 'Data/Hora Fim',
      width: 160,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {new Date(params.row.endDate).toLocaleString('pt-BR')}
        </Typography>
      )
    },
    
  ];

  return (
    <DatabaseTable
      rows={reservations}
      columns={columns}
      loading={isLoading}
      onView={onView}
      hideDelete
      hideEdit
    />
  );
}